export default __webpack_public_path__ + "media/images/steps/steps-dog-body-8ae3e9488ec8811f59c86e989b693058.svg";